import { AclMenuChanges, AclMenuChangesResponseDTO } from "@dto/aclResponse.dto"
import { AdminGroupsResponseDTO } from "@dto/adminGroups.dto"
import { BasicResponseDTO } from "@dto/basicResponse.dto"
import {
  GroupDTO,
  GroupResponseDTO,
  LdapGroupsResponseDTO,
  UpdateLdapGroupDTO
} from "@dto/groupsResponse.dto"
import { MenuResponseDTO } from "@dto/menuResponse.dto"
import axios, { AxiosResponse } from "axios"
import { postApi, putApi } from "src/util/apiCalls"
import { GROUPS_API_URL } from "../interfaces/constants"
import { updGroup } from "../interfaces/types"

export interface IMenuResponseDTO extends MenuResponseDTO {
  statuses: {
    denied?: string[]
    granted?: string[]
    inherited?: string[]
    partial?: string[]
  }
}

export const postGroupsAPI = async (data: GroupDTO): Promise<AxiosResponse<GroupResponseDTO>> => {
  try {
    const response = await postApi<GroupResponseDTO, GroupDTO>(GROUPS_API_URL.ALL, data)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getServersAPI = async (
  isGroupEditing: boolean,
  id?: string
): Promise<AdminGroupsResponseDTO> => {
  try {
    const response = await axios.get<AdminGroupsResponseDTO>(
      isGroupEditing ? GROUPS_API_URL.MANAGES + `?group_id=${id}` : GROUPS_API_URL.MANAGES
    )
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getServersById = async (id: string): Promise<IMenuResponseDTO> => {
  try {
    const response = await axios.get<IMenuResponseDTO>(`${GROUPS_API_URL.SERVERS}?group_id=${id}&statuses=true`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getServersByIdMultiple = async (ids: number[]): Promise<IMenuResponseDTO> => {
  try {
    const groups = ids.map((id) => `group_id=${id}`).join('&')
    const response = await axios.get<IMenuResponseDTO>(`${GROUPS_API_URL.SERVERS}?${groups}&statuses=true`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getManagementById = async (id: string): Promise<IMenuResponseDTO> => {
  try {
    const response = await axios.get<IMenuResponseDTO>(`${GROUPS_API_URL.MANAGES}?group_id=${id}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const putTreeAclAPI = async (id: string, checkedKeysACL: AclMenuChanges) => {
  try {
    const response = await putApi<BasicResponseDTO, AclMenuChangesResponseDTO>(
      GROUPS_API_URL.CHANGES + id,
      { data: checkedKeysACL }
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const putGroupAPI = async (id: string, data: GroupDTO) => {
  try {
    const response = await putApi<GroupResponseDTO, GroupDTO>(GROUPS_API_URL.ALL + id, data)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const delGroupAPI = async (id: string) => {
  try {
    const response = await axios.delete<BasicResponseDTO, GroupResponseDTO>(GROUPS_API_URL.ALL + id)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const updTransferAPI = async (
  data: updGroup,
  user_id: string
) => {
  try {
    const response = await putApi<GroupResponseDTO, GroupDTO>(
      GROUPS_API_URL.ALL + user_id,
      data
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
export const deleteTreeRulesAPI = async (user_id: string): Promise<BasicResponseDTO> => {
  try {
    const response = await axios.delete<BasicResponseDTO, BasicResponseDTO>(GROUPS_API_URL.RULES + user_id)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getLdapGroupsAPI = async () => {
  try {
    const response = await axios.get<LdapGroupsResponseDTO>(GROUPS_API_URL.LDAP_GROUP)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const putLdapGroupsByIdAPI = async (id: string, data: UpdateLdapGroupDTO) => {
  try {
    const response = await putApi<BasicResponseDTO, UpdateLdapGroupDTO>(GROUPS_API_URL.LDAP_GROUP + `/${id}`, data)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
